import { GridFilterItem } from '@mui/x-data-grid-pro';

import { httpClient, HttpMethod } from './http-client';
import { QueryOption } from '../@types';
import { NotificationConfigListResponse, NotificationConfigObject, NotificationTemplateListResponse } from '../@types/notification.type';

export const getNotificationConfigsByCateogry = (category: string, queryOptions: QueryOption): Promise<NotificationConfigListResponse> => {
  const { filterModel, page, pageSize, sortModel } = queryOptions;
  let url = `/notificationConfigs?page=${page + 1}&limit=${pageSize}&category=${category}`;

  if (sortModel && sortModel[0] && sortModel[0].field) {
    url += `&order_by=${sortModel[0].field}&order_direction=${sortModel[0].sort}`;
  }

  filterModel?.items?.forEach((filter: GridFilterItem) => {
    url += `&${filter?.field}=${filter?.operator},${filter.value}`;
  });

  return httpClient<NotificationConfigListResponse>(url, HttpMethod.Get);
};

export const createNotificationConfig = (configData: NotificationConfigObject): Promise<NotificationConfigObject> => {
  return httpClient<NotificationConfigObject>('/notificationConfigs', HttpMethod.Post, configData);
};

export const updateNotificationConfig = (id: number, configData: NotificationConfigObject): Promise<NotificationConfigObject> => {
  return httpClient<NotificationConfigObject>(`/notificationConfigs/${id}`, HttpMethod.Put, configData);
};

export const getNotificationTemplates = (): Promise<{ data: NotificationTemplateListResponse[] }> => {
  return httpClient<{ data: NotificationTemplateListResponse[] }>('/notificationTemplates', HttpMethod.Get);
};